import React from 'react';

import ModalV2, { ModalV2Props } from '../Modal/ModalV2';
import { SimpleSignupForm, SimpleSignupFormProps } from './SimpleSignupForm';

import {
  mapCardTypeToBusinessCategory,
  mapCardTypeToBusinessUnitComponent,
} from '../../paper/cards/util/trackingHelpers';

import styles from './simpleSignupModal.module.less';

type SimpleSignupModalProps = Omit<ModalV2Props, 'dialogHeadingId' | 'triggerRef'> &
  Omit<SimpleSignupFormProps, 'businessCategory' | 'businessUnitComponent'> & {
    cardType: string;
  };

export const SimpleSignupModal = ({
  cardType,
  closeModal,
  fetchUserContext,
  flowEntry,
  isPushSignupIntoCustomization,
  loginCallback,
  loginLinkCallback,
  shouldShowPartnerField,
  shouldTrackOnboarding,
  userContext,

  /** ModalV2Props */
  onClose,
  rootId,
}: SimpleSignupModalProps) => {
  return (
    <ModalV2
      dialogHeadingId="simple-signup-title"
      lockBgScrolling
      onClose={onClose}
      rootId={rootId}
      triggerRef={null}
    >
      <div className={styles.simpleSignupModalContent}>
        <SimpleSignupForm
          businessCategory={mapCardTypeToBusinessCategory(cardType)}
          businessUnitComponent={mapCardTypeToBusinessUnitComponent(cardType)}
          closeModal={closeModal}
          fetchUserContext={fetchUserContext}
          flowEntry={flowEntry}
          isPushSignupIntoCustomization={isPushSignupIntoCustomization}
          loginCallback={loginCallback}
          loginLinkCallback={loginLinkCallback}
          shouldShowPartnerField={shouldShowPartnerField}
          shouldTrackOnboarding={shouldTrackOnboarding}
          userContext={userContext}
        />
      </div>
    </ModalV2>
  );
};
